import React, { ReactNode, useMemo } from 'react';
import { useTranslation } from '../../contexts/TranslationsContext';
import { ComponentsMap, parseTemplate, renderNodes } from './TrCore';

function interpolateParams(text: string, params?: readonly string[]): string {
  if (!params || params.length === 0 || text.indexOf('{') === -1) return text;
  return text.replace(/\{(\d+)\}/g, (m, idxStr) => {
    const idx = Number(idxStr);
    return Number.isFinite(idx) && idx >= 0 && params && idx < params.length ? String(params[idx]) : m;
  });
}

type TrProps = {
  trKey: string;
  components?: ComponentsMap;
  params?: readonly string[];
  fallback?: ReactNode;
};

export const Tr: React.FC<TrProps> = ({ trKey, components, params, fallback }) => {
  const { getValue } = useTranslation();
  const raw = getValue(trKey);

  const nodes = useMemo(() => {
    if (!raw) return null;
    const interpolated = interpolateParams(raw, params);
    return parseTemplate(interpolated);
  }, [raw, params]);

  if (!nodes) return <>{fallback ?? trKey}</>;
  return <>{renderNodes(nodes, components ?? {}, 'k')}</>;
};
